import { supabaseClient } from "@/lib/supabase";
import { useQuery } from "@tanstack/react-query";

const selectStaff = async (organisationId: string) => {
	const { data, error } = await supabaseClient
		.from("profiles")
		.select("*")
		.overlaps("roles", ["CLINICIAN", "SECRETARY"]);

	if (error) throw error;
	return data.filter((staff) =>
		(staff.organisations as { organisation_id: string; role: string }[])?.some(
			(org) =>
				org.organisation_id === organisationId &&
				["CLINICIAN", "SECRETARY"].includes(org.role),
		),
	);
};

export const selectStaffQueryKey = ["select-staff"];

export const useSelectStaffByOrganisationId = (organisationId: string) => {
	return useQuery({
		queryKey: selectStaffQueryKey,
		queryFn: () => selectStaff(organisationId),
	});
};
